// src/services/storyApi.js — the browser's stories (the phone's twin is
// services/storyApi.ts). Reading goes through the server, where friends-only and
// blocks are decided (server/functions/storyRoutes.js); posting is
// services/vibes.publishStories, beside the post writer it shares the look with.
import { postJson } from './vibeSocial';

export const fetchStoryFeed = () => postJson('/api/stories/feed', {});
export const markStoryViewed = (storyId) => postJson('/api/stories/view', { storyId });
export const fetchStoryViewers = (storyId) => postJson('/api/stories/viewers', { storyId });
export const reactStory = (storyId, emoji) => postJson('/api/stories/react', { storyId, emoji });
export const replyStory = (storyId, text) => postJson('/api/stories/reply', { storyId, text });
export const deleteStory = (storyId) => postJson('/api/stories/delete', { storyId });
